(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agreements', {
                parent: 'app',
                url: '/agreements',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.agreements.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/agreements-workflow/agreements.html',
                        controller: 'AgreementsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('agreements');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: 263447,
                }
            });

    }

})();
